import { render, staticRenderFns } from "./OzonKategori.vue?vue&type=template&id=458a5f3a&scoped=true"
import script from "./OzonKategori.vue?vue&type=script&lang=js"
export * from "./OzonKategori.vue?vue&type=script&lang=js"
import style0 from "./OzonKategori.vue?vue&type=style&index=0&id=458a5f3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458a5f3a",
  null
  
)

export default component.exports